// extracted by mini-css-extract-plugin
export var boldCellText = "_611fbf4c6029012052d8c2d449104c42-css";